<template>
  <el-container>
    <div class="g-aside-main">
      <div v-for="(st, index) in stList" :key="index">
        <el-row style="margin: 0 0 10px">
          <pre style="font-size: 16px; font-weight: bold" v-html="st.tg"></pre>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row
              v-for="(stxx, index2) in st.stxxList"
              :key="index2"
              style="margin: 5px"
            >
              <el-col style="width: calc(100% - 170px)">
                <div class="editorHtml" v-html="stxx.sm"></div>
              </el-col>
              <el-col style="width: 165px"
                >选择率:
                <span style="color: blue"
                  >{{ stxx.xzl }}% （{{ stxx.num }}/{{ stxx.total }}）</span
                ></el-col
              >
            </el-row>
            <el-row style="margin-top: 20px">
              <el-col style="width: 80px">标准答案：</el-col>
              <el-col style="width: calc(100% - 100px)">
                <pre class="editorHtml" v-html="st.stda.bzda"></pre>
              </el-col>
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col style="width: 80px">答案解析：</el-col>
              <el-col style="width: calc(100% - 100px)">
                <pre class="editorHtml" v-html="st.stda.dajx"></pre>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <ve-pie
              :data="setchartData(st.zql, st.cwl)"
              :settings="chartSettings"
            ></ve-pie>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-container>
</template>
<script>
import { stPage } from '@/api/report'
export default {
  data () {
    this.chartSettings = {
      dimension: 'type',
      metrics: 'zb',
      radius: 100
    }
    return {
      tmid: null,
      stList: [],
      chartData: {
        rows: [
          { type: '正确率', zb: 40 },
          { type: '错误率', zb: 60 }
        ]
      }
    }
  },
  props: {
    stObj: Object
  },
  watch: {
    stObj: {
      handler (val, oldVal) {
        this.loadStList()
      },
      deep: true // 对象内部的属性监听，也叫深度监听
    }
  },
  methods: {
    setchartData (zql, cwl) {
      const chartData = {
        rows: [
          { type: '正确率', zb: zql },
          { type: '错误率', zb: cwl }
        ]
      }
      return chartData
    },
    loadStList () {
      const params = this.stObj
      stPage(params).then(res => {
        this.$http.callback(res, () => {
          this.stList = res.data
        })
      })
    }
  },
  created () {
    this.loadStList()
  }
}
</script>
